import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  standalone: true,
  name: 'tmwSafeHtml',
})
export class TmwSafeHtmlPipe implements PipeTransform {
  constructor(private sanitized: DomSanitizer) {}
  transform(value: string): any {
    return this.sanitized.bypassSecurityTrustHtml(value);
  }
}
